import { SIGNUP_PAGE } from 'src/constants';
import {
  STUDIO_REFERRER,
  STUDIO_STEP_PARAM,
  STUDIO_STEP_WORKSPACE_SETUP,
} from 'src/routes/onboarding/setup/constants';
import { UrlUtils } from 'src/utils';

export type BuildStudioSignupPathInput = {
  prompt?: string;
  workspaceTemplateId?: string;
  workspaceTemplateName?: string;
  /** Post-auth redirect to carry across the flow (mirrors the login path). */
  next?: string;
  /** When true, resume at Studio workspace setup after email select. */
  workspaceSetup?: boolean;
};

export const buildStudioSignupPath = ({
  prompt,
  workspaceTemplateId,
  workspaceTemplateName,
  next,
  workspaceSetup = false,
}: BuildStudioSignupPathInput = {}): string => {
  const params: Record<string, string> = {
    referrer: STUDIO_REFERRER,
  };

  if (workspaceSetup) {
    params[STUDIO_STEP_PARAM] = STUDIO_STEP_WORKSPACE_SETUP;
  }
  if (prompt) {
    params.prompt = prompt;
  }
  if (workspaceTemplateId) {
    params.template_id = workspaceTemplateId;
    if (workspaceTemplateName) {
      params.template_name = workspaceTemplateName;
    }
  }
  if (next) {
    params.next = next;
  }

  return `${SIGNUP_PAGE}?${UrlUtils.FormatUrlQueryToString(params)}`;
};
